<p-dialog [(visible)]="showStatusDialog" [modal]="true" [style]="{width: '400px'}" [closeOnEscape]="true"
[closable]="true" [showHeader]="false">

<div class="flex flex-column align-items-center p-4 gap-4">
  <i class="pi pi-question-circle text-4xl text-primary"></i>
  <p class="text-xl font-semibold m-0">
    Wash Out Needed?
  </p>
</div>

<ng-template pTemplate="footer">
  <div class="flex justify-content-center w-full gap-2 px-4 pb-4">
    <button pButton label="Generate Form" icon="pi pi-file" class="p-button-primary flex-1"
      (click)="prepareTrailerNumber()">
    </button>
    <button pButton label="Skip" icon="pi pi-times" class="p-button-outlined p-button-secondary flex-1"
      (click)="showStatusDialog = false">
    </button>
  </div>
</ng-template>
</p-dialog>

